import React from 'react';
import styled from 'styled-components';

import { EmptyList } from '@/assets/icons';

interface IProps {
  label: string;
  className?: string;
}

const ResourcesNoData = ({ label, className }: IProps): React.ReactElement => {
  return (
    <Container className={className}>
      <Content>
        <Icon src={EmptyList} />
        <Label>{label}</Label>
      </Content>
    </Container>
  );
};

export { ResourcesNoData };

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  border-radius: 8px;
  margin-top: 10px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
  padding: 24px 0;
  width: 100%;
  margin: 26px 24px;
`;

const Label = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
  margin: 0 0 0 17px;
`;

const Icon = styled.img`
  height: 20px;
`;
